import { inject, Injectable } from '@angular/core';
import { catchError, EMPTY, map, Observable } from 'rxjs';
import {
  Community,
  EmptyResponse,
  ListOfBasicUsers,
  Project,
  DefaultService as RestApiService,
} from 'src/app/swagger-api';
import { RedirectUrlParams } from '../interfaces/query-url-params.interface';
import { authContext } from './api-error';
import { INVITATION_STATUSES_MAPPER } from './helpers/url-query-handler.helpers';

@Injectable({
  providedIn: 'root',
})
export class UrlQueryRequestsService {
  private apiService = inject(RestApiService);

  public verifyEmail(verifyToken: string, email: string): Observable<EmptyResponse> {
    return this.apiService.restAuthVerifyEmailPut(verifyToken, authContext(email)).pipe(catchError(() => EMPTY));
  }

  public communityMembersPut(params: RedirectUrlParams): Observable<string> {
    return this.apiService
      .restSocialCommunityMembersPut(
        { invitation_status: INVITATION_STATUSES_MAPPER[params.serverAction] },
        params.entityId,
        params.actorId,
      )
      .pipe(map(() => params.url));
  }

  public projectMembersPut(params: RedirectUrlParams): Observable<string> {
    return this.apiService
      .restSocialProjectMembersPut(
        { invitation_status: INVITATION_STATUSES_MAPPER[params.serverAction] },
        params.entityId,
        params.actorId,
      )
      .pipe(map(() => params.url));
  }

  public getUserInfo(userId: string): Observable<ListOfBasicUsers> {
    return this.apiService.restUserIndex([userId]);
  }

  public getCommunityInfo(entityId: string): Observable<Community> {
    return this.apiService.restSocialCommunitiesGet(entityId);
  }

  public getCharityInfo(entityId: string): Observable<Community> {
    return this.apiService.restSocialCharitiesGet(entityId);
  }

  public getProjectInfo(entityId: string): Observable<Project> {
    return this.apiService.restSocialProjectsGet(entityId);
  }
}
